import { useActions } from '@/hooks'
import {
  Map,
  Placemark,
  SearchControl,
  ZoomControl,
} from '@pbe/react-yandex-maps'
import MapCircle from '@/modules/maps/components/Circle'
import DtpPlacemark from '@/modules/maps/components/DtpPlacemark'
import React, { FC, memo, useRef, useState } from 'react'
import { Cluster } from '@/modules/maps/types/unitsMapType'
import { MAP_ZOOM_OPTIONS } from '@/modules/maps/HomeMap'
import ymaps from 'yandex-maps'
export type UnitDtp = {
  coordinates: number[]
  id: number
  isGroup: boolean
  severityTypeId: number
  smart: boolean
  typeId: number
}

interface Props {
  center: number[]
  setNewCoords: (coords: number[]) => void
  dataUnits: UnitDtp[] | undefined
  newCoords: number[]
  draggable: boolean
  isHomePage?: boolean
  clusters: Cluster[]
  onGetDataWithShowDots: (showDots: boolean, bounds: any) => Promise<void>
  disabled?: boolean
}

export const getColorUnit = (id: number): string => {
  let res = '#FF3E00'

  if (id === 1) res = '#FFD21E'
  if (id === 2) res = '#FF7F24'
  if (id === 3) res = '#FF3E00'
  if (id === 16) res = '#ffd902'
  if (id === 17) res = '#db3615'
  return res
}

const MapDTP: FC<Props> = ({
  center,
  setNewCoords,
  dataUnits,
  clusters,
  newCoords,
  draggable,
  isHomePage = false,
  onGetDataWithShowDots,
  disabled,
}) => {
  const yMap = useRef<any>()
  const [zoomState, setZoomState] = useState(8)
  const { setIsChangeFeatures } = useActions()
  const refPlacemark = useRef<any>(null)
  const lastRequestTimeRef = useRef<number>(0)

  const handleMapClick = (event: any) => {
    if (!isHomePage && !disabled) {
      const clickedCoords = event.get('coords')
      setNewCoords(clickedCoords)
      setIsChangeFeatures(true)
    }
  }
  // console.log(111, center, newCoords)
  const handlePlacemarkDragEnd = () => {
    const draggedCoords = refPlacemark.current.geometry?._coordinates
    if (draggedCoords) {
      setNewCoords(draggedCoords)
      setIsChangeFeatures(true)
    }
  }

  // const onSetBounds = (e: typeof ymaps) => {
  //     console.log('set center onSetBounds')
  //     const lat = searchParams.get('lat')
  //     const lng = searchParams.get('lng')
  //     if (!lat && !lng) {
  //         const bounds = e.util.bounds.fromPoints(points)
  //         console.log('onSetBounds2')
  //         yamap?.current?.setBounds(bounds, {
  //             checkZoomRange: true,
  //         })
  //     }
  // }

  return (
    <Map
      instanceRef={yMap}
      state={{ center, zoom: 8, controls: [] }}
      options={{ yandexMapDisablePoiInteractivity: true }}
      modules={['control.ZoomControl']}
      width='100%'
      height='100%'
      onClick={handleMapClick}
      // onLoad={onSetBounds}
      onBoundsChange={async (e: any) => {
        const now = Date.now()
        if (now - lastRequestTimeRef.current >= 1000) {
          lastRequestTimeRef.current = now
          const showDots = e.originalEvent.newZoom >= 14
          await onGetDataWithShowDots(showDots, e.originalEvent.newBounds)
        }
        setZoomState(e.originalEvent.newZoom)
        console.log('Zoom = ', e.originalEvent.newZoom)
      }}
    >
      {!isHomePage && (
        <SearchControl options={{ float: 'left', noPlacemark: true }} />
      )}
      <ZoomControl options={MAP_ZOOM_OPTIONS} />
      {clusters?.map((unit) => (
        <MapCircle
          key={unit.id}
          unit={unit}
          zoomState={zoomState}
          yMap={yMap}
        />
      ))}

      {dataUnits?.map((unit) => (
        <DtpPlacemark
          key={unit.id}
          unit={unit}
          unitTotal={dataUnits.length}
        />
      ))}

      {!isHomePage && (
        <Placemark
          instanceRef={refPlacemark}
          onDragEnd={disabled ? undefined : handlePlacemarkDragEnd}
          geometry={newCoords}
          options={{
            preset: 'islands#circleDotIcon',
            iconColor: '#0072BC',
            // iconImageOffset: [-7.5, -7.5],
            draggable: draggable && !disabled,
          }}
          properties={{ iconContent: '+' }}
        />
      )}
    </Map>
  )
}

export default memo(MapDTP)
